<template>
  <div>
    <div v-if="errorStatus" class="alert alert-danger my-3" role="alert">
      An error occurred that prevented us showing your data. 
      <a href="#" @click="showErrorDetail=!showErrorDetail">{{showErrorDetail?"Hide details":"Show details"}}</a>
      <div v-if="showErrorDetail"  v-html="errorStatus"></div>

    </div>
    <div v-else-if="isLoading" class="d-flex align-items-center justify-content-center" style="min-height:300px">
        <div class="spinner-border mx-2" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        Loading...
    </div>
    <div v-else-if="noData">
      <div v-if="errorStatus" class="alert alert-info my-3" role="alert">
        An error occurred that prevented us showing your data. 
        <a href="#" @click="showErrorDetail=!showErrorDetail">{{showErrorDetail?"Hide details":"Show details"}}</a>
        <div v-if="showErrorDetail"  class="fs-sm" >{{errorStatus}}</div>
      </div>
    </div>
    <div v-else-if="!selectedLocation" class="row justify-content-md-center">
      <div class="col-12">
        <h5>Please add a location to get started</h5>
        
        <div class="input-group">
          <div class="btn px-1 disabled" >
            <i class="bi bi-geo"></i>
          </div>
          <input v-model="newLocation" v-on:keyup.enter="setLocation()" class="form-control border-end-0  border-primary" type="text" placeholder="Enter a location" aria-describedby="locationHelpBlock">
          <span class="input-group-append">
              <button @click="setLocation()" class="btn btn-primary  border-start-0 border-primary ms-n1" :class="{disabled:!newLocation}" type="button" >
                  <i class="bi bi-search"></i>
              </button>
          </span>
        </div>
        <div class="ps-1 pt-1" ><a href="#" @click.prevent.stop="findMyLocation()"><i class="bi bi-broadcast-pin"></i> Use your location</a></div>
      </div>
    </div>
    <div v-else id="maincontent" class="row justify-content-md-center">
      <div class="col-12">
        <div class="row">
          <h3 class="h3 col-12 col-md-7 text-truncate"> <!--<template v-if="basePeriodLabel">{{basePeriodLabel}} for </template>-->
            <a href="#" class="dropdown-toggle" id="locationDropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">{{selectedLocation.location}} <!--<i class="bi bi-pencil"></i>--></a>
            <ul class="dropdown-menu p-1" aria-labelledby="dropdownMenuButton1">
              <li><div class="fw-bold mt-3">Enter address or partial address:</div></li>
              <li> 
                <div class="d-flex align-items-center p-1">
                  <input v-model="newLocation" v-on:keyup.enter="setLocation()" class="form-control" type="text" placeholder="Enter a location">
                  <button @click="setLocation()" type="button" class="btn btn-sm btn-translucent-primary "> <i class="bi bi-search"></i></button>
                </div>
                <a class="ps-2 pt-0" href="#" @click.prevent.stop="findMyLocation()"><i class="bi bi-broadcast-pin"></i> Use your location</a>
              </li>
              <template v-if="hasLocationsHistory">
                <li><div class="fw-bold mt-3">History:</div></li>
                <li v-for="(loc,index) in locationsHistory"  @click="setLocation(loc)"><a class="dropdown-item" href="#" >{{loc.location}}</a></li>
              </template>
            </ul>
           
          </h3> 
          <DateRangeChooser v-if="showDateRangeChooser" class="col-8 col-md-4" :queryDefinition="selectedQueryDefn" :queryData="selectedQueryData" @change:daterange="setDateRange" v-slot="{ title }">
            <a href="#dataEditorModal" data-bs-toggle="modal" class="text-primary h3 ms-0 ps-0">
                    {{title}}
            </a> 
          </DateRangeChooser>

          <div class="btn-group  col-4 col-md-1  ms-auto noscreenshot" role="group" aria-label="Solid button group">
            <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:unitGroup==='us'}" @click="setUnitGroup('us')">F</button>
            <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:unitGroup==='metric'}" @click="setUnitGroup('metric')">C</button>
          </div>
        </div>

        <div v-if="showApiControls" class="d-flex align-items-center justify-content-end noscreenshot">
          <button type="button" class="btn text-primary btn-sm"  @click="showApiQueries()"><i class="bi bi-code-slash"></i><span class="d-none  d-lg-inline"> Weather API</span></button>
          <button type="button" class="btn text-primary btn-sm"  @click="takeScreenshot()"><i class="bi bi-camera"></i><span class="d-none  d-lg-inline"> Screenshot (beta)</span></button>
          <button type="button" class="btn text-primary btn-sm"  @click="refreshPage(cloneQueryDefn(), '/weather-query-builder')"><i class="bi bi-download"></i><span class="d-none  d-lg-inline"> Data Download </span></button>
          <button type="button" class="btn text-primary btn-sm"  @click="copyLink()"><i class="bi bi-share"></i><span class="d-none  d-lg-inline"> Share </span></button>
        </div>
        
        <div v-if="enableCostSaverMode && hasSession && costSaverMode" class="alert alert-primary my-3" role="alert">
          <i class="bi bi-info"></i>You are in free mode. You can preview, design and experiment without charging your account.
            When you are ready, you may view or download the full dataset. Some features may be available in preview mode that are not available to your plan level.
            <a  class="" href="#" @click="changeCostSaver(false)"> View the full dataset</a>.
        </div>

        <div v-if="dataStoredError" class="alert alert-danger my-3" role="alert">
          An error occurred that prevented us showing your data. 
          <a href="#" @click="showErrorDetail=!showErrorDetail">{{showErrorDetail?"Hide details":"Show details"}}</a>
          <div v-if="showErrorDetail" class="fs-sm" v-html="dataStoredError"></div>
        </div>
        <template v-else-if="view==='dailysummary'">
          <DaySummaryWidget :config="todayDaySummaryConfig"  :weatherData="selectedQueryData" :parentData="parentData"/>
          <MultiPeriodChartWidget :config="todayMultiPeriodConfig"  :weatherData="selectedQueryData" :parentData="parentData"/>

          <h3 class="mt-3">{{basePeriodLabel}}'s detailed weather information for {{selectedLocation.location}}</h3> 
          <DaySummaryWidget  :config="todayDetailedDaySummaryConfig"  :weatherData="selectedQueryData" :parentData="parentData"/>
<!--
          <h3 class="mt-3">Last 10 days weather data for  {{selectedLocation.location}}</h3> 

          <MultiPeriodChartWidget  :config="last10DaysMultiPeriodConfig" />
-->
        </template>
         <template v-else-if="view==='forecast'">
           <h3 class="mt-3">Currently</h3> 
          <div class="row">
            <DaySummaryWidget class="" :config="forecastCurrentSummaryConfig"  :weatherData="selectedQueryData" :parentData="parentData"/>
          </div>
          <h3 class="mt-3">3 Day outlook</h3> 
          <div class="row">
            <DaySummaryWidget class="" :config="forecastDaySummaryConfig"  :weatherData="selectedQueryData" :parentData="parentData"/>
          </div>
          <h3 class="mt-3">Hourly forecast</h3> 
          <MultiPeriodChartWidget :config="forecastDaySummaryConfigHourly"  :weatherData="selectedQueryData" :parentData="parentData"/>

          <h3 class="mt-3">Long term outlook</h3> 
          <MultiPeriodChartWidget :config="forecastMultiPeriodConfig"  :weatherData="selectedQueryData" :parentData="parentData"/>

        </template>


        <template v-else-if="view==='history'">
          <div class="row justify-content-center mt-3 mb-3">
            <div v-for="kpi in kpiIds" class="col-4 col-md-2 border-1 shadow-sm py-2 rounded-3">
              <div class="text-muted fs-xs">{{summmaryKpis[kpi].label}}</div>
              <div class="fs-2 text-center">{{summmaryKpis[kpi].fvalue}}</div>
            </div>
          </div>

         <!-- Update the template section -->
        <div v-if="true" class="justify-content-center mt-3 mb-3 ">
          <div class="features-container position-relative" >
            <transition-group name="fade" tag="div" class="row g-2 m-0 w-100 justify-content-center">
             <div v-for="(feature, index) in currentFeatures" :key="feature.id" 
                  class="col-12 col-md-10 col-lg-6 mb-3"
                  :class="{ 'd-none d-lg-block': index > 0 }">
                <div class="card border-0 shadow-sm overflow-hidden " 
                    @click="navigateToFeature(feature)"
                    :class="`hover-${feature.color}`"
                    style="cursor: pointer;">
                  <div class="row g-0 ">
                    <div class="col-3 position-relative overflow-hidden">
                      <div class="position-absolute top-0 start-0 w-100 h-100">
                        <img :src="'/images/marketing/'+feature.icon" 
                            :alt="feature.title" 
                            class="w-100 h-100"
                            style="object-fit: cover; object-position: center;">>
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="card-body px-2 py-2" style="min-height: 120px;">
                        <h6 class="card-title">{{ feature.title }}</h6>
                        <p class="card-text mb-2">
                          {{ getFirstSentence(feature.description) }}
                        </p>
                        <p class="card-text mb-2" >
                          {{ getRemainingText(feature.description) }}
                        </p>
                      <div class="position-absolute bottom-0 end-0 p-2">
                        <span  :class="`text-${feature.color}`">
                          <small class="text-body-secondary"><i class="bi bi-arrow-right-circle me-1"></i>Learn More</small>
                        </span>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
        </div>

          <MultiPeriodChartWidget :config="historyMultiPeriodConfig" :weatherData="selectedQueryData" :parentData="parentData"/>

          <h3 class="mt-3">Location and station map</h3> 
          <StationInfoWidget  ref="stationInfoWidget" :config="historyMultiPeriodConfig" :weatherData="selectedQueryData" :parentData="parentData"/>
        </template>
         <template v-else>
          Unexpected view requested
        </template>
      </div>
    </div>
   

  <div class="modal fade" id="apiQueryEditorModal" tabindex="-1" aria-labelledby="apiQueryEditorModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="apiQueryEditorModalLabel">Weather API Queries</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">
              <p>This page is populated using the <a href="/weather-api">Visual Crossing Weather API</a> using the following query. 
              To build Weather API queries for yourself, head over to our <a href="/weather-query-builder">Weather Query Builder</a> page. Also see our <a href="/resources/documentation/weather-api/timeline-weather-api/">API docs</a> 
               </p>
              <div class="d-flex mt-3 align-items-center ">
                <div class="fw-bold">Available queries</div>
                 <button class="dropdown-toggle btn text-primary px-1" type="button" id="queryDefnDropdownButton" data-bs-toggle="dropdown" aria-expanded="false" >
                  {{selectedQueryDefnLabel}}
                </button>
                <ul class="dropdown-menu" aria-labelledby="queryDefnDropdownButton">
                  <li v-for="u in queryDefinitions"  @click="selectedQueryDefn=u"><a class="dropdown-item" href="#" v-html="u.id"></a></li>
                </ul>
              </div>
              <ApiQuery v-if="selectedQueryDefn" :sessionState="sessionState" :queryDefinition="selectedQueryDefn"></ApiQuery>
              <div v-else>Please select a query definition</div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </form>
        </div>
      </div>
    </div>


     <CommonModals />

  </div>
 
</template>

<script>
//import { Calendar, DatePicker } from 'v-calendar';
import CommonModals from '/src/components/CommonModals.vue'
import "/src/visualcrossing-core/vccommunicator_account";
import {VcLocationsStorage} from "/src/visualcrossing-core/vclocationsstorage";
//import {VcPrettyNumberFormatter} from '/src/visualcrossing-core/vcprettynumberformatter';
//import {VcDateUtils} from "/src/visualcrossing-core/vcdateutils";
//import {VcGlobal} from '/src/visualcrossing-core/vcglobal_conn';
//import '/src/website-core/VcUtils'
import ApiQuery from '/src/components/ApiQuery.vue';
import DateRangeChooser from '/src/components/DateRangeChooser.vue';
import MultiPeriodChartWidget from '/src/wxwidgets/multi-period-chart-widget.vue';
import DaySummaryWidget from '/src/wxwidgets/day-summary-widget.vue';
import StationInfoWidget from '/src/wxwidgets/station-info-widget.vue';
//import '/src/wxwidgets/wxwidgets.scss';
import {VcWidgetHelper} from '/src/wxwidgets/common_widget.js'
import {VcClipboardUtils} from '/src/visualcrossing-core/vcclipboardutils';
import {VcFindMyLocation} from '/src/visualcrossing-core/vcfindmylocation';
import {VcDateUtils} from '/src/visualcrossing-core/vcdateutils';
import {VcTimezone} from '/src/visualcrossing-core/vctimezone';
//import domtoimage from 'dom-to-image';
import html2canvas from 'html2canvas';
import { weatherFeatures, getRandomFeatures } from '@/data/weatherFeatures';

export default {
  name: 'weathersummary',
  props: {
    
  },
  data() {
    return {
      view:'dailysummary',
      sessionId:null,
      sessionState:null,
      errorStatus:null,
      showErrorDetail:false,
      isLoading:true,
      selectedLocation:null,
      unitGroup:null,
      rooturl:null,
      startdate:null,
      basePeriodLabel:null,
      newLocation:null,
      locationsHistory:null,
      queryDefinitions:[],
      selectedQueryDefn:null,
      selectedQueryData:null,
      showApiControls:true,
      dataStoredError:null,
      parentData:false,
      costSaverMode:true,
      enableCostSaverMode:false,
      currentFeatures: [],
      featureRotationInterval: null,
      featureRotationDelay: 20000, // 8 seconds
    }
  },
  methods:{
    changeCostSaver(value, confirm) {
      console.log("Change cost saver");
      let me=this;
      if (!value && !confirm) {
        window.VcCommonModals.showConfirm("Confirm full dataset mode", 
        "Enabling full dataset mode will show all rows of your dataset with in the browser. Your account will be debited for this data usage and charges may apply. You may return to preview mode at any time. Do you want to continue?")
          .then(function(id) {
            me.changeCostSaver(value, true);
          }).catch((error) => {
          
          });
  
        return;
      }
      me.costSaverMode=value;
      me.parentData= me.costSaverMode;
      me.weatherData=null;
    },
    takeScreenshot() {

      // Ensure the map is resized before taking the screenshot
      if ( this.$refs.stationInfoWidget) this.$refs.stationInfoWidget.preScreenshot()

      const contentDiv = document.getElementById('maincontent');

      // Use html2canvas to take a screenshot of the contentDiv excluding elements with class 'exclude'
      html2canvas(contentDiv, {
              useCORS: true,
              backgroundColor: '#ffffff', // Ensure white background
              scale: 2, // Higher quality
              logging: false,
              windowWidth: contentDiv.scrollWidth + 40, // Add extra width for shadows
              windowHeight: contentDiv.scrollHeight + 40, // Add extra height for shadows
              x: -20, // Offset to capture shadow
              y: -20, // Offset to capture shadow
              ignoreElements: function(element) {
                return element.classList.contains('noscreenshot');
              }
      }).then(function(canvas) {
          // Convert the canvas to a data URL (PNG image)
          const imgData = canvas.toDataURL('image/png');

          // Create an anchor element to trigger the download
          const link = document.createElement('a');
          link.href = imgData;
          link.download = 'screenshot.png';  // Set the default filename
          link.click();  // Trigger the download
      }).catch(function(error) {
          console.error('Error generating screenshot:', error);
      });
      /*
      var node = document.getElementById('maincontent');

      domtoimage
          .toPng(node)
          .then(function (dataUrl) {
              var link = document.createElement('a');
              link.download = 'weather-history-dashboard.png';
              link.href = dataUrl;
              link.click();
          }).catch(function (error) {
              console.error('oops, something went wrong!', error);
          });
      */
    },
    showApiQueries() {
      var me=this;
      me.refreshQueryDefns();
      //if (me.queryDefinitions && me.queryDefinitions.length) me.selectedQueryDefn=me.queryDefinitions[0];
      var target=this.$el && this.$el.querySelector("#apiQueryEditorModal");
      var modal = bootstrap.Modal.getOrCreateInstance(target);
      modal.show();
    },
    cloneQueryDefn() {
      let me=this;
      if (!me.selectedQueryDefn) {
        return {
          location:null,
          name:null,
          startdate:null,
          enddate:null,
          unitgroup:"us",
        }

      }
      let defn= JSON.parse(JSON.stringify(me.selectedQueryDefn));
      return defn;
    },
    setDateRange(startPeriod, endPeriod) {
      
      let me=this;
      let defn= me.cloneQueryDefn();
      defn.startdate=startPeriod;
      defn.enddate=endPeriod;
      console.log("Set date range:"+defn.startdate +"=> "+defn.enddate);
      me.refreshPage(defn);
    },
    findMyLocation() {
      var me=this;
      var fml=VcFindMyLocation.findMyLocation(true);

      fml.then(location=> {
          //me.setLocation(location);
          me.newLocation=location;
        })
        .catch(error=>{
          console.log("Could not find location..."+error)
        });
    },
    setLocation(newLocation) {
      
      let me=this;
      let selectedLocation=null;
      if (newLocation && newLocation.location) {
          selectedLocation=newLocation;
        } else if (newLocation) {
          selectedLocation={
            location:newLocation,
            name:null,
          };
        } else {
          selectedLocation={
            location:me.newLocation,
            name:null,
          };
        }


      
      if (!me.costSaverMode) {
        me.selectedLocation=selectedLocation;
        //me.newLocation=null;
        me.saveLocation(me.selectedLocation);

      }

      let defn=me.cloneQueryDefn();

      defn.location=selectedLocation.location;
      defn.name=null;

      me.newLocation=null;
      me.refreshPage(defn);
  
    },
    saveLocation(newLocation) {
      var me=this;
      VcLocationsStorage.addLocation(newLocation);
      me.refreshLocationsHistory();
    },
    setUnitGroup(unitGroup) {
      var me=this;
      //me.unitGroup=unitGroup
      //VcLocationsStorage.setUnitGroup(me.unitGroup);

      let defn=me.cloneQueryDefn();

      defn.unitgroup=unitGroup;

      me.refreshPage(defn);
    },
    createLink(defn, rooturl) {

      if (!defn) {
        console.log("No defn passed to createLink");
        return "???";
      }
      let me=this;
      rooturl=rooturl || me.rooturl;
      
      let url=(rooturl || "") 
      if (!url.endsWith("/")) url += "/";

      url += defn.location;
      url+="/"+defn.unitgroup;
      if (defn.startdate) {
        url+="/"+defn.startdate;
        if (defn.enddate) url+="/"+defn.enddate;
      }
      url+="/";
      return url;


    },
    copyLink() {
      var me=this;

      var url=me.createLink(me.selectedQueryDefn, me.rooturl);
      VcClipboardUtils.copyToClipboard(window.location.origin+url);
      VcCommonModals.showToast("Link copied", "The dashboard link been copied to the clipboard.")
    },

    refreshPage(defn, rooturl) {
      var me=this;

      if (!me.costSaverMode) {

        me.refreshData();
        return;
      }

      var url=me.createLink(defn, rooturl);
      console.log(`refreshPage:${url}`)
    
      console.log(`checking for navigation:${window.navigation}`);

      if (window.navigation) {
        me.isLoading=true;
        window.navigation.addEventListener("navigate", (event) => {
          setTimeout(()=> {
            me.isLoading=false;
          }, 60000);
          
          //console.log(event);
          return;
          
        });
      } else {
        me.isLoading=true;
      }

      window.location=url;
    },


    refreshData(defn) {
      var me=this;
      if (me.parentData) {
        if (me.weatherData) {
          const newValue=me.weatherData;
          VcWidgetHelper.processData(newValue); 
      
          me.wxdata=newValue;
        }
        return;
      }

    
    let vcCommunicator=window.vcCommunicator;
    vcCommunicator.retrieveTimelineData(defn,  defn.location, defn.name, "json", true, false)
      .then(response => {
        var data=response;
       
        VcWidgetHelper.processData(data);  
        me.wxdata=data;
        if (me.wxdata.unitGroup ) {
          me.unitGroup=me.wxdata.unitGroup;
          VcLocationsStorage.setUnitGroup(me.unitGroup);
        }

        if (me.wxdata && me.wxdata.days && me.wxdata.days.length<4 && me.wxdata.days[0] && me.wxdata.days[0].hours) {
          me.period="hours";
        }
        me.selectedQueryData=me.wxdata;
        me.selectedQueryDefn=defn;
       
      }).catch((error) => {
        me.errorStatus=(error) || "An unknown error occurred";
      });
   


      /*
      VcWidgetHelper.populateData( {
                    location:me.location,
                    startdate:me.selectedQueryDefn.startdate,
                    enddate:me.selectedQueryDefn.enddate,
                    key:me.key,
                    unitgroup:me.selectedQueryDefn.unitGroup,
                    elements:me.selectedQueryDefn.elements,
                    include:me.selectedQueryDefn.include,
                    options:me.selectedQueryDefn.options,
                    forecastBasisDate:me.selectedQueryDefn.forecastBasisDate,
                    forecastBasisDay:me.selectedQueryDefn.forecastBasisDay,
                    id:me.id,
                    forceRefresh:me.forceRefresh
                })
      .then(response => {
        var data=response.data;
       
        VcWidgetHelper.processData(data);  
        me.wxdata=data;
        if (me.wxdata.unitGroup ) me.unitGroup=me.wxdata.unitGroup;
        

        if (me.wxdata && me.wxdata.days && me.wxdata.days.length<4 && me.wxdata.days[0] && me.wxdata.days[0].hours) {
          me.period="hours";
        }
        me.selectedQueryData=me.wxdata;


      }).catch((error) => {
          me.error=(error && error.msg) || "An unknown error occurred";
      });
      */
    },
    refreshLocationsHistory() {
      //console.log("refreshLocationsHistory")'
      let me=this;
      /*
      if (me.parentData) {
        console.log("refreshLocationsHistory disabled as data from parent");
        return;
      }
        */
      me.locationsHistory=VcLocationsStorage.getLocations();
    },
    refreshQueryDefns() {
      var me=this;
      var queryDefns=VcWidgetHelper.queryDefinitions;
      queryDefns=queryDefns && Object.values(queryDefns);
      if (!queryDefns || !queryDefns.length) {
        if (me.selectedQueryDefn) {
          me.selectedQueryDefn.id=me.selectedQueryDefn.id || "Default query";

          me.queryDefinitions=[me.selectedQueryDefn];
        } else {
          me.queryDefinitions=[];
        }
        
        return;
      }
      me.queryDefinitions=[];
      queryDefns.forEach(function(defn) {
        if (defn) me.queryDefinitions.push(defn);
      });
      if (me.queryDefinitions && me.queryDefinitions.length) {
        me.selectedQueryDefn=me.queryDefinitions[0];
        me.selectedQueryData=VcWidgetHelper.getDataset(me.selectedQueryDefn.id);
      }
    },

    formatTime(date) {
     // var datetz=VcTimezone.toTz(date, 'utc', true);
      return VcDateUtils.formatDateCustom(date,"HHmm");
    },
    formatDateIso(dateTime) {
      return VcDateUtils.formatDateTime2(dateTime);
    },
    rotateFeatures() {
      // Get 2 random features that are different from current ones
      let newFeatures = getRandomFeatures(2);
      
      // Ensure we don't get the same features
      while (this.currentFeatures.length > 0 && 
             newFeatures.some(nf => this.currentFeatures.some(cf => cf.id === nf.id))) {
        newFeatures = getRandomFeatures(2);
      }
      
      this.currentFeatures = newFeatures;
    },
    
    startFeatureRotation() {
      // Initial features
      this.rotateFeatures();
      
      // Set up rotation interval
      this.featureRotationInterval = setInterval(() => {
        this.rotateFeatures();
      }, this.featureRotationDelay);
    },
    
    stopFeatureRotation() {
      if (this.featureRotationInterval) {
        clearInterval(this.featureRotationInterval);
        this.featureRotationInterval = null;
      }
    },
    
    navigateToFeature(feature) {
      // Use the feature's url and target properties
      if (window["gtag"]) {
        gtag('event', 'vc_upsell', { 
          method : 'Vc',
          feature_id: feature.id
         });
      }
      if (feature.url) {
        if (feature.target === '_blank') {
          // Open in new tab/window
          window.open(feature.url, '_blank');
        } else {
          // Navigate in same window
          window.location.href = feature.url;
        }
      } else {
        console.warn(`Feature ${feature.title} does not have a URL defined.`);
      }
    },
    
    getFirstSentence(description) {
      // Split by period and get first sentence
      const sentences = description.split('. ');
      return sentences[0] + '.';
    },
    
    getRemainingText(description) {
      // Split by period and get remaining sentences
      const sentences = description.split('. ');
      if (sentences.length > 1) {
        // Remove first sentence and join the rest
        return sentences.slice(1).join('. ');
      }
      return '';
    },
  },
  
  mounted() {
    // ...existing mounted code...
    
    // Start feature rotation if on history view
    if (this.view === 'history') {
      this.startFeatureRotation();
    }
  },
  computed:{
    apiKey() {
      let me=this;

    },

    summmaryKpis() {
      var me=this;
      return VcWidgetHelper.calcSummaryKpis(me.selectedQueryData, me.unitGroup);

    },
    kpiIds() {
      var kpis=this.summmaryKpis;
      return kpis && Object.keys(kpis);
    },
    showDateRangeChooser() {
      return this.view==="history"; // && this.selectedQueryDefn;
    },
    selectedQueryDefnLabel() {
      var queryDefn=this.selectedQueryDefn;
      if (queryDefn) return queryDefn.id;
      return "-";
    },
    hasLocationsHistory() {
      return this.locationsHistory && this.locationsHistory.length;
    },

   
  
    todayDaySummaryConfig() {
      console.log("todayDaySummaryConfig")
      return {
          id:this.startdate,
          startdate:this.startdate,
          location:this.selectedLocation.location,
          // dayindex:"0",
          viewincludes:'date,icon,desc,periods',
          include:"fcst,obs,histfcst,stats,days,hours",
          summarykpis:'tempmax,tempmin,rainsnow,precipprob',
          unitgroup:this.unitGroup,
          };
    },
    todayMultiPeriodConfig() {
      return {
            id:this.startdate,
            startdate:this.startdate,
            location:this.selectedLocation.location,
           // dayindex:"0",
            period:"hours",
            include:"fcst,obs,histfcst,stats,days,hours",
					  viewincludes:'periodsummary',
            unitgroup:this.unitGroup,
           };
    },
    todayDetailedDaySummaryConfig() {
      return {
          id:this.startdate,
          startdate:this.startdate,
          location:this.selectedLocation.location,
          // dayindex:"0",
          include:"fcst,obs,histfcst,stats,days,hours",
          viewincludes:'date,temp,feekslike,precip,snow,wind,humidity,pressure,solar,astro,periods',
          unitgroup:this.unitGroup,
        };
    },
    historyMultiPeriodConfig() {
      return {
         id:"history",
          location:this.selectedLocation.location,
          startdate:this.startdate || "last15days",
          enddate:this.enddate,
          include:"fcst,obs,histfcst,stats",
          viewincludes:'temp,precip,wind,degreedays',
          options:"",
          elements:"datetime,datetimeEpoch,temp,tempmax,tempmin,precip,windspeed,windgust,feelslike,feelslikemax,feelslikemin,pressure,stations,degreedays,accdegreedays",
          unitgroup:this.unitGroup,
          };
    },
    last10DaysMultiPeriodConfig() {
      return {
         id:"10dayobs",
           location:this.selectedLocation.location,
            startdate:"last10days",
            enddate:"",
            include:"fcst,obs,histfcst,stats",
					  viewincludes:'temp,precip,wind',
            unitgroup:this.unitGroup,
           };
    },

    forecastMultiPeriodConfig() {
      return {
            id:"forecast",
            startdate:null,
            location:this.selectedLocation.location,
           // dayindex:"0",
            period:"days",
            include:"fcst,obs,histfcst,stats,days,hours,current,alerts",
					  viewincludes:'periodsummary',
            unitgroup:this.unitGroup,
           }
    },
    forecastDaySummaryConfig() {
      return {
          id:"forecast",
          startdate:null,
          location:this.selectedLocation.location,
          dayindex:0,
          enddayindex:2,
          columncount:3,
          viewincludes:'date,icon,desc',
          include:"fcst,obs,histfcst,stats,days,hours,current,alerts",
          summarykpis:'tempmax,tempmin,rainsnow,precipprob',
          unitgroup:this.unitGroup,
          };
    },
    forecastDaySummaryConfigHourly() {
      return {
          id:"forecast",
          startdate:null,
          location:this.selectedLocation.location,
          /*dayindex:0,
          enddayindex:0,*/
          maxDayIndex:1,
          period:"hours",
          include:"fcst,obs,histfcst,stats,days,hours,current,alerts",
				  viewincludes:'periodsummary',
          unitgroup:this.unitGroup,
          };
    },
    forecastCurrentSummaryConfig() {
      return {
          id:"forecast",
          startdate:null,
          location:this.selectedLocation.location,
          dayindex:-1,
          viewincludes:'current,alerts,date,icon,desc,astro',
          include:"fcst,obs,histfcst,stats,days,hours,current,alerts",
          options:"beta",
          summarykpis:'temp,feelslike,precip,wind',
          unitgroup:this.unitGroup,
          };
    },

   forecastMultiPeriodConfig2() {
      return {
            id:"forecast2",
            startdate:null,
            location:this.selectedLocation.location,
            options:"beta",            
            period:"days",
            include:"fcst,days,hours,current,alerts",
					  viewincludes:'periodsummary',
            unitgroup:this.unitGroup,
           }
    },
    forecastDaySummaryConfig2() {
      return {
          id:"forecast2",
          startdate:null,
          location:this.selectedLocation.location,
          dayindex:0,
          enddayindex:7,
          columncount:1,
          viewincludes:'date,icon,desc',
          include:"days,hours,current,alerts",
          options:"",
          summarykpis:'tempmax,tempmin,rainsnow,precipprob,wind,pressure,sunrise,sunset,uvindex2',
          unitgroup:this.unitGroup,
          };
    },

    noData() {
      return false;
    },
    hasSession() {
      return this.sessionId;
    },

  },
  beforeUnmount() {
    // ...existing code...
    this.stopFeatureRotation();
  },
  
  watch: {
    view(newView) {
      if (newView === 'history') {
        this.startFeatureRotation();
      } else {
        this.stopFeatureRotation();
      }
    }
  },
  
  created() {
    console.log("created...");
  },
 
  
  beforeMount() {
    console.log("beforeMount...");
  },
  beforeUpdate() {
    //console.log("beforeUpdate...");
  },
  updated() {
    //console.log("updated...");
  },
  beforeUnmount() {
    console.log("beforeUnmount...");
    var me=this;
  },
  activated() {
    console.log("activated...");
    var me=this;
  },
  deactivated() {
    console.log("deactivated...");
    var me=this;
  },
  unmounted() {
    console.log("unmounted...");
    var me=this;
  },
  mounted() {
    var me=this;

    console.log("mounted...");
    var containerElement=me.$el.parentElement;
    me.view=containerElement.getAttribute('data-view') || "dailysummary"
   

  
    var savedUnitGroup=VcLocationsStorage.getUnitGroup();
    
    var unitGroup;
    var startdate=containerElement.getAttribute('data-baseperiod');
    var enddate=null;
    var queryData=null;
    var queryDefn=null;
    const vcconfig=window.vcconfig;
    if (vcconfig) {
      if (vcconfig.location==="<?php echo $location ?>") vcconfig.location="Herndon,VA";
      if (vcconfig.unitGroup==="<?php echo $unitGroup ?>") vcconfig.unitGroup="us";
      if (vcconfig.startdate==="<?php echo $startDate ?>") vcconfig.startdate="today";
      if (vcconfig.enddate==="<?php echo $endDate ?>") vcconfig.enddate="";

      if (!vcconfig.isDefault || !lastLocation) {
        if (vcconfig.location) {
          me.selectedLocation={
            location:vcconfig.location,
            name:null
          }
          me.saveLocation(me.selectedLocation);
          me.refreshLocationsHistory();
         
        }
        if (vcconfig.unitGroup) {
          unitGroup=vcconfig.unitGroup;
          if (unitGroup) VcLocationsStorage.setUnitGroup(unitGroup);
        }

        if (vcconfig.startdate) {
          startdate=vcconfig.startdate;
        }

        if (vcconfig.enddate) {
          enddate=vcconfig.enddate;
        }


        if (vcconfig.queryData) {
          queryData=vcconfig.queryData;
          queryDefn={
                //locationOrDefn:vcconfig.location,
                location:vcconfig.location,
                startdate:vcconfig.startdate,
                enddate:vcconfig.enddate,
                unitgroup:vcconfig.unitGroup,
                contentType:"json",
            }
        }
        if (vcconfig.hasServerData) {
          me.parentData=true; 
          lastLocation=null;
          if (vcconfig.errorCode>0) {
            if (vcconfig.error) {
              me.dataStoredError=vcconfig.error;
            } else {
              me.dataStoredError=`Error occurred loading data (${vcconfig.errorCode})`;
            }
          }  
        }

      }
    }

    me.refreshLocationsHistory();

    var lastLocation=me.hasLocationsHistory && me.locationsHistory[0];
    
    me.selectedLocation=me.selectedLocation || lastLocation;
    me.unitGroup=unitGroup || savedUnitGroup || "us";

    me.rooturl=containerElement.getAttribute('data-rooturl');

    if (lastLocation && me.parentData && !queryData && vcconfig.errorCode<=0) {
      let defn= me.cloneQueryDefn();
      defn.location=lastLocation.location;
      defn.name=null;
      defn.unitGroup=savedUnitGroup || "us";
      me.refreshPage(defn, null);
      return;
    }

    if (me.unitGroup!==savedUnitGroup) {
      VcLocationsStorage.setUnitGroup(me.unitGroup);
    }

    me.startdate=startdate;
    me.enddate=enddate;
    me.selectedQueryData=queryData;
    me.selectedQueryDefn=queryDefn;
    me.basePeriodLabel=containerElement.getAttribute('data-baseperiodlabel') 

    const showapicontrols=containerElement.getAttribute('data-showapicontrols');
    if (showapicontrols) {
      me.showApiControls=showapicontrols==="true";
    }
    
    
    var vcCommunicator=window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
    me.sessionId=vcCommunicator.sessionId;
    me.sessionState=vcCommunicator.sessionState;
    vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
      me.sessionId=sessionId;
      me.sessionState=sessionState;
     
      
    });
     vcCommunicator.addHandler('terminatesession', function () {
       me.sessionId=null;
    });

    VcWidgetHelper.addHandler("datastored", function (id, defn, data) {
      me.selectedQueryDefn=defn;
      me.selectedQueryData=data && data.result==="success" && data.data;
      me.dataStoredError=null;
    })
      
    VcWidgetHelper.addHandler("datastorederror", function (id, defn,msg) {
      me.selectedQueryDefn=defn;
      me.dataStoredError=msg;
    })
    me.isLoading=false;


    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        console.log('This page was restored from the bfcache.');
      } else {
        console.log('This page was loaded normally.');
      }
      me.isLoading=false;
    });

    window.addEventListener('pagehide', (event) => {
      if (event.persisted) {
        console.log('This page *might* be entering the bfcache.');
      } else {
        console.log('This page will unload normally and be discarded.');
      }
      me.isLoading=false;
    });
  },
  components: {
    ApiQuery,
    MultiPeriodChartWidget,
    DaySummaryWidget,
    StationInfoWidget,
    DateRangeChooser,
    CommonModals
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* ...existing styles... */

/* Features container */
.features-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  min-height: 120px; /* Reduced from implicit height */
}

/* Smooth fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

/* Position elements absolutely during transition */
.fade-leave-active {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

.fade-enter-active {
  position: static !important;
  z-index: 2;
}

/* Ensure proper grid layout */
.features-container > div {
  display: flex;
  flex-wrap: wrap;
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}

/* Feature cards specific height - not all cards */
.feature-card {
  min-height: 100px; /* Much smaller height */
  max-height: 120px; /* Constrain maximum height */
}

/* Ensure image column maintains aspect ratio */
.feature-card .col-4 {
  height: 120px; /* Fixed height for image column */
}

/* Compact text styles */
/*
.feature-card h5 {
  font-size: 0.95rem !important;
  line-height: 1.2;
}

.feature-card h6 {
  font-size: 0.8rem !important;
  line-height: 1.3;
}

.feature-card p {
  font-size: 0.75rem !important;
  line-height: 1.2;
  margin-bottom: 0.5rem !important;
}


.feature-card .card-body {
  padding: 0.75rem !important;
}
*/
/* Make cards interactive */
.feature-card {
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

/* Color-specific hover effects */
.feature-card.hover-primary:hover {
  border-left: 3px solid var(--bs-primary);
}

.feature-card.hover-success:hover {
  border-left: 3px solid var(--bs-success);
}

.feature-card.hover-info:hover {
  border-left: 3px solid var(--bs-info);
}

.feature-card.hover-warning:hover {
  border-left: 3px solid var(--bs-warning);
}

/* Ensure text doesn't get selected on click */
.feature-card {
  user-select: none;
}

/* Hover effect for the "Learn More" text */
.feature-card:hover .small {
  text-decoration: underline;
}
</style>